import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService, LocationService, UserService } from '@app/_services';
import { CourseService } from '@app/_services/course.service';
import { first } from 'rxjs/operators';

@Component({ selector: 'soi-results', templateUrl: 'soi-results.component.html' })
export class SOIResultsComponent {

    results: any[];
    @Input() course: any;

    constructor(private locationService: LocationService, private courseService: CourseService, private router: Router) { }

    ngOnInit() {
        this.getResults();
    }

    getResults() {
        this.locationService.getFrontlineCommunityResults().subscribe(data => {
            this.results = data;
        });
    }

    onViewFullResults() {
        this.courseService.getCourse(this.course.courseId).pipe(first()).subscribe(data => {
            this.router.navigate(['/course-section', data.resultsSectionId]);
        });
    }
}